var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileVine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m300.1,14.37c21.27,8.88 8.48,52.19 -1.58,65.95c-10.06,13.76 -42.6,28.08 -77.2,26.15c-34.61,-1.92 -66.37,-27.74 -98.53,-27.09c-32.16,0.66 -49.46,23.17 -49.81,45.45c-0.35,22.28 18.45,47.14 48.34,55.22c29.89,8.08 54.11,-7.32 86.36,-17.34c32.26,-10.02 91.94,-32.66 87.22,3.19c-4.72,35.85 -35.56,55.64 -36.01,95.5c-0.44,39.86 51.8,45.19 36.01,107.33c-15.79,62.14 -275.59,64.13 -277.9,129.88c-2.31,65.75 130.7,69.88 190.81,65.1c60.12,-4.78 116.41,-46.18 94.71,-91.85c-21.7,-45.68 -207.98,-10.78 -221.78,-71.99c-13.8,-61.22 102.83,-71.7 123.58,-106.6c20.75,-34.91 -73.21,-41.04 -94.29,-44.81c-21.07,-3.77 -81.9,-26.89 -97.94,-104.24c-16.04,-77.36 2.61,-102.36 29.06,-113.86c26.45,-11.5 118.73,-20.71 135.12,-21.59c16.39,-0.88 102.53,-3.27 123.8,5.61z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_15",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVine2);
export default __webpack_public_path__ + "static/media/mobileVine2.827e06f7a835f8ad5fde7532ddcd751f.svg";
export { ForwardRef as ReactComponent };